import classNames from 'classnames';
import type { InteractiveAtomSize } from '../utils/InteractiveAtomProps';

interface SubMenuItemParams {
  size: InteractiveAtomSize;
  isOpen: boolean;
  expandable: boolean;
  isDisabled?: boolean;
  selected?: boolean;
  className?: string;
}

const baseClassName =
  'w-full flex flex-col gap-xs rounded-lg border border-transparent';

const sizeClassName: {
  [key in InteractiveAtomSize]: string;
} = {
  large: 'text-sm p-sm',
  default: 'text-sm p-sm',
  small: 'text-sm py-xs px-sm',
};

const subMenuItemStateClassName = {
  hovered: 'hover:bg-state-hover',
  focused: 'focus:outline-none focus:ring focus:!border-transparent',
  disabled: 'text-status-disabled-dark',
  selected:
    'bg-status-selected text-status-selected !border-status-selected font-bold',
  disabledSelected:
    'text-status-disabled-dark !border-status-disabled-dark font-bold',
};

export const getSubMenuItemClassNames = ({
  size = 'default',
  isDisabled,
  selected,
  expandable,
  isOpen,
  className = '',
}: SubMenuItemParams): string => {
  const isSelectable = !expandable;
  const isDisabledSelected = isDisabled && selected && isSelectable;
  const isDisabledOnly = isDisabled && (!selected || (selected && expandable));

  return classNames(
    className,
    baseClassName,
    sizeClassName[size],
    !isOpen && !isDisabled && subMenuItemStateClassName.hovered,
    !isDisabled && subMenuItemStateClassName.focused,

    isDisabledOnly && subMenuItemStateClassName.disabled,
    isSelectable &&
      !isDisabled &&
      selected &&
      subMenuItemStateClassName.selected,
    isDisabledSelected && subMenuItemStateClassName.disabledSelected,
  );
};
